import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React from 'react';
import { Spinner } from '@instructure/ui-spinner';
import t from '@instructure/quiz-i18n/format-message';
export default (function (depsAreLoaded, loadDeps) {
  return function (WrappedComponent) {
    var _Wrapper;
    return _Wrapper = /*#__PURE__*/function (_WrappedComponent) {
      function Wrapper(props) {
        var _this2;
        _classCallCheck(this, Wrapper);
        _this2 = _callSuper(this, Wrapper, [props]);
        var depsLoaded = depsAreLoaded();
        _this2.state = Object.assign({}, _this2.state, {
          depsLoaded: depsLoaded
        });
        if (!depsLoaded) {
          loadDeps().then(function () {
            _this2.setState({
              depsLoaded: true
            });
          });
        }
        return _this2;
      }
      _inherits(Wrapper, _WrappedComponent);
      return _createClass(Wrapper, [{
        key: "render",
        value: function render() {
          return this.state.depsLoaded ? _get(_getPrototypeOf(Wrapper.prototype), "render", this).call(this) : /*#__PURE__*/React.createElement(Spinner, {
            renderTitle: t('loading')
          });
        }
      }]);
    }(WrappedComponent), _defineProperty(_Wrapper, "displayName", "".concat(_Wrapper.name, "(").concat(WrappedComponent.displayName, ")")), _Wrapper;
  };
});